import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SectionHeader, ReadingProgress } from "@/components/site/primitives";
import { fadeUp, stagger } from "@/lib/motion";
import { bookHref } from "@/lib/bookModel";
import { resolveMockBookId } from "@/components/bookDetails/utils/resolveMockBookId";
import { CONTINUE_READING } from "@/data";
import BookCoverArt from "@/components/books/BookCoverArt";

export default function ContinueReading() {
  return (
    <section className="u-container mt-12 md:mt-16" data-testid="home-continue-reading">
      <SectionHeader eyebrow="Pick up where you left off" title="Continue Reading" />
      <motion.div variants={stagger} initial="hidden" animate="show" className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CONTINUE_READING.map((book, i) => (
          <motion.div key={book.title} variants={fadeUp} custom={i}>
            <Link to={bookHref(resolveMockBookId(book))} state={{ hint: book }} className="card-paper flex gap-4 p-4">
              <BookCoverArt book={book} className="h-20 w-14 shrink-0 shadow-card" />
              <div className="flex min-w-0 flex-1 flex-col justify-between">
                <div>
                  <p className="truncate font-display text-[15px] font-semibold leading-snug text-ink">{book.title}</p>
                  <p className="text-xs text-subtle">{book.author}</p>
                </div>
                <ReadingProgress value={book.progress} label={`p. ${book.page} of ${book.total}`} />
              </div>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
